<template>
  <v-container class="ma-0 pa-0">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.3894066122707!2d80.03851065148403!3d12.818094690912348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52f769d774e39d%3A0x1cb92ab85459d1fb!2sMaayaas%20Stay!5e0!3m2!1sen!2sus!4v1578189892343!5m2!1sen!2sus"
      width="100%" height="450"
      frameborder="0" style="border:0;" allowfullscreen="">
    </iframe>
  </v-container>
</template>

<script>

export default {
  name: 'Map',

  data: () => ({
  }),
};
</script>
